import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {getFeatureFlag} from '../../feature-flags';
import {appHistory} from '../../history';

import EmailArt from './email-configure-cta-modal-artwork.svg';

import styles from './email-configure-cta-modal.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export class EmailConfigureCtaModal extends React.PureComponent<Props> {
    render() {
        const isDemoSilo = getFeatureFlag('isDemoSilo');
        const primaryAction = {onClick: this.handleOpenConfigModal} as const;

        return (
            <Modal
                canClickOutsideToClose={true}
                closeButton={false}
                noPadding={true}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                maxHeight={500}
            >
                <OnboardingPage
                    type='singlePage'
                    buttonText={isDemoSilo ? 'Back to account' : 'Connect'}
                    artImage={<Art />}
                    bodyComponent={isDemoSilo ? <DemoBody /> : <ConfigBody />}
                    artBackgroundColor={colors.plumLt}
                    primaryAction={isDemoSilo ? {onClick: this.handleExitDemo} : primaryAction}
                    onClose={this.props.onClose}
                />
            </Modal>
        );
    }

    handleOpenConfigModal = () => {
        this.props.onClose();
        appHistory.push({
            hash: '/connect-email/get-started',
            search: location.search,
        });
    };

    handleExitDemo = () => {
        Nut.ajax.post({
            url: '/instance/switch-to-primary.json',
            dataType: 'json',
            contentType: 'application/json',
        });
    };
}

const ConfigBody = () => (
    <OnboardingBody title='Send emails through Nutshell!'>
        <div>
            <p>
                Connect your email and start sending customers and prospects emails directly through
                your Nutshell account.
            </p>
        </div>
    </OnboardingBody>
);

const DemoBody = () => (
    <OnboardingBody title='Sending emails is disabled in demo'>
        <div>
            <p>
                You’re currently in the Nutshell demo. To configure and send email, you’ll need to
                return to your real account.
            </p>
        </div>
    </OnboardingBody>
);

const Art = () => (
    <div className={styles.art}>
        <EmailArt />
    </div>
);
